import { z } from 'zod';

export const transcriptSchema = z.array(
    z.object({
        time: z.string(),
        speaker: z.string(),
        text: z.string(),
    }),
);

export type Transcript = z.infer<typeof transcriptSchema>;
